@for (item of items; track item) {
  <div
    class="loader"
    [ngClass]="[type(), animation()]"
    >
  </div>
}
